import DefaultApiService from "./default";

const BASE = "SLN/Management/DistributionNetwork";

const wrap = (res, fallback) => ({
  ok: res?.isSuccess !== false && res?.IsSuccess !== false,
  message: res?.message || res?.Message || "",
  data: res?.data ?? res?.Data ?? fallback,
});

const DistributionNetworkApi = {
  getCompanyLookups: async () =>
    wrap(await DefaultApiService.getCustomeApi(`${BASE}/GetCompanyLookups`), []),

  getAreaLookups: async (companyId) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${BASE}/GetAreaLookups${companyId ? `?companyId=${companyId}` : ""}`
      ),
      []
    ),

  getCompanies: async (includeInactive = true) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${BASE}/GetCompanies?includeInactive=${includeInactive}`
      ),
      []
    ),
  getCompany: async (id) =>
    wrap(await DefaultApiService.getCustomeApi(`${BASE}/GetCompany?id=${id}`)),
  getCompanyCities: async (companyId) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${BASE}/GetCompanyCities?companyId=${companyId}`
      ),
      []
    ),
  getCompanyHierarchy: async (companyId) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${BASE}/GetCompanyHierarchy?companyId=${companyId}`
      )
    ),
  saveCompany: async (payload) =>
    wrap(await DefaultApiService.postApi(`${BASE}/SaveCompany`, payload)),
  deleteCompany: async (id) =>
    wrap(await DefaultApiService.postApi(`${BASE}/DeleteCompany?id=${id}`, {})),

  getAreas: async ({ companyId, includeInactive = true } = {}) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${BASE}/GetAreas?includeInactive=${includeInactive}${
          companyId ? `&companyId=${companyId}` : ""
        }`
      ),
      []
    ),
  getArea: async (id) =>
    wrap(await DefaultApiService.getCustomeApi(`${BASE}/GetArea?id=${id}`)),
  saveArea: async (payload) =>
    wrap(await DefaultApiService.postApi(`${BASE}/SaveArea`, payload)),
  deleteArea: async (id) =>
    wrap(await DefaultApiService.postApi(`${BASE}/DeleteArea?id=${id}`, {})),

  getContacts: async ({ companyId, areaId, includeInactive = true } = {}) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${BASE}/GetContacts?includeInactive=${includeInactive}${
          companyId ? `&companyId=${companyId}` : ""
        }${areaId ? `&areaId=${areaId}` : ""}`
      ),
      []
    ),
  getContact: async (id) =>
    wrap(await DefaultApiService.getCustomeApi(`${BASE}/GetContact?id=${id}`)),
  saveContact: async (payload) =>
    wrap(await DefaultApiService.postApi(`${BASE}/SaveContact`, payload)),
  deleteContact: async (id) =>
    wrap(await DefaultApiService.postApi(`${BASE}/DeleteContact?id=${id}`, {})),
};

export default DistributionNetworkApi;
